import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textSObj } = typographyStyles;

const white = colors.ui.white[700];
const neutral200 = colors.ui.neutral[200];
const neutral500 = colors.ui.neutral[500];
const neutral600 = colors.ui.neutral[600];

export const buttonCss = {
  alignItems: "flex-start",
  borderRadius: "12px",
  color: neutral600,
  display: "flex",
  margin: "0 0 12px 0",
  padding: "16px 19px",
  textAlign: "left",
  width: "100%",
  font: "inherit",
  gap: 0,

  div: {
    display: "flex",
    width: "100%",
  },
};

export const ctaContainer = {
  flexDirection: "column",
};

export const headlineCss = {
  ...textSObj,
  fontWeight: "normal",
  lineHeight: "1.3rem",
  margin: 0,
  color: neutral600,
};

export const headlineContainerCss = {
  display: "flex",
  columnGap: "13px",

  "& > div": {
    display: "flex",
    flexDirection: "column",
  },
};

export const iconCss = {
  height: "24px",
  width: "24px",

  path: {
    fill: neutral500,
    stroke: neutral500,
    strokeWidth: "1px",
  },
};

export const curatedFormativeConnectionOptionsCss = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  columnGap: "5px",
  justifyContent: "flex-start",
  marginTop: "10px",
};

export const curatedFormativeConnectionOption = {
  ...textSObj,
  padding: "8px 12px",
  border: `1px solid ${neutral200}`,
  borderRadius: "100px",
  backgroundColor: white,
  color: neutral500,
  width: "auto",
};
